import { useMemo } from 'react';

import { ProposalPreviewProps } from '~/data/proposals';
import {
  GetProposalPreviewProps,
  useGetProposalPreview,
} from '~/data/proposals/useGetProposalPreview';

type PropsType = {
  details: GetProposalPreviewProps;
  positions: GetProposalPreviewProps;
};

export type UseEmploymentProposalsPreviewData = {
  detailsPreview?: ProposalPreviewProps;
  positionPreview?: ProposalPreviewProps;
  isLoading: boolean;
  hasData: boolean;
};

export const useEmploymentProposalsPreviewData = (
  props: PropsType,
): UseEmploymentProposalsPreviewData => {
  const previewRequestConfigProps = { shouldRetryOnError: false };

  const detailsPreviewOutput = useGetProposalPreview(
    props.details,
    previewRequestConfigProps,
  );

  const positionPreviewOutput = useGetProposalPreview(
    props.positions,
    previewRequestConfigProps,
  );

  const { isLoading, hasData } = useMemo(() => {
    const isLoading =
      detailsPreviewOutput.isLoading || positionPreviewOutput.isLoading;

    const hasData = !!detailsPreviewOutput.data && !!positionPreviewOutput.data;

    return {
      isLoading,
      hasData,
    };
  }, [detailsPreviewOutput, positionPreviewOutput]);

  return {
    detailsPreview: detailsPreviewOutput.data,
    positionPreview: positionPreviewOutput.data,
    isLoading,
    hasData,
  };
};
